export default "__VITE_ASSET__DWJ6KIAo__"